import makeInitials from 'initials';
import { usePersonId } from 'src/components/providers/PersonIdProvider';
import usePerson from 'src/graphql/hooks/usePerson';
export const useInitials = ({
  person
}) => {
  const personReferenceId = usePersonId();
  const {
    data
  } = usePerson({
    variables: {
      personReferenceId
    },
    skip: !personReferenceId || !!person
  });
  const source = person ?? data;
  return !source?.firstName || !source?.lastName ? '' : makeInitials([source?.firstName, source?.lastName].join(' '));
};